export default {
  id: 'conclusion/MEDICATION/v1',
  formSchema: {
    title: 'encounter:widget.conclusion.medications',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.conclusion.medications',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
